import GeomTool from "../geom/GeomTool";

export default class TextUtils
{
    /**
     * Function to sample points from a text.
     * Beware this draws on the main canvas, so it should probably be used at the start 
     * of the program only
     * @param text Text to be dispalyed
     * @param options Object with text options: size, font, style, W, H
     * @param numPoints Number of points to be sampled
     */
    static samplePointsFromText( text, options, numPoints){
        const p5App = window.p5App;
        p5App.textSize(options.size);
        p5App.textFont(options.font);
        p5App.textStyle(options.style);
        let tWidth = p5App.textWidth( text );
        let tHeight = p5App.textAscent( text );
        p5App.background( '#ffffff' );
        p5App.fill(0);
        p5App.text( text, (options.W*.5)-tWidth*0.5, (options.H*.5)+tHeight*0.5-500);
        let points = GeomTool.samplePoints(numPoints, options.W, options.H);
        p5App.clear();
        return points;
    }
}